import { Category } from '@/admin/topics/models';
import { CoreQuery } from '@/common/services/core-query';
import { EntitiesList } from '@/common/models';
import { httpClientCoreQuery } from '@/api/http-client';

export function createEditCategory(category: Category) {
    const q = new CoreQuery().path([EntitiesList.TOPICS, EntitiesList.PERSONA, EntitiesList.CATEGORY]);

    return httpClientCoreQuery.put(q, category).then(({ data }) => data);
}
